import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'html-to-pdf',
  version: '1.0.0',
  properties: [
    {
      key: 'htmlContent',
      label: 'HTML Content',
      type: 'text',
      required: false,
      default: '',
      placeholder: '<html><body>Your content here</body></html>',
      description: 'HTML content to convert. Leave empty to use output from previous node.',
      typeOptions: {
        rows: 10,
      },
    },
    {
      key: 'fileName',
      label: 'File Name',
      type: 'string',
      required: false,
      default: 'document.pdf',
      placeholder: 'report.pdf',
      description: 'Output file name for the PDF',
    },
    {
      key: 'pageSize',
      label: 'Page Size',
      type: 'options',
      required: false,
      default: 'A4',
      options: [
        { value: 'A3', name: 'A3' },
        { value: 'A4', name: 'A4' },
        { value: 'A5', name: 'A5' },
        { value: 'LETTER', name: 'Letter (US)' },
        { value: 'LEGAL', name: 'Legal (US)' },
        { value: 'TABLOID', name: 'Tabloid' },
      ],
    },
    {
      key: 'orientation',
      label: 'Orientation',
      type: 'options',
      required: false,
      default: 'portrait',
      options: [
        { value: 'portrait', name: 'Portrait' },
        { value: 'landscape', name: 'Landscape' },
      ],
    },
    {
      key: 'marginTop',
      label: 'Top Margin (mm)',
      type: 'number',
      default: 20,
      description: 'Top page margin in millimeters',
    },
    {
      key: 'marginBottom',
      label: 'Bottom Margin (mm)',
      type: 'number',
      default: 20,
      description: 'Bottom page margin in millimeters',
    },
    {
      key: 'marginLeft',
      label: 'Left Margin (mm)',
      type: 'number',
      default: 20,
      description: 'Left page margin in millimeters',
    },
    {
      key: 'marginRight',
      label: 'Right Margin (mm)',
      type: 'number',
      default: 20,
      description: 'Right page margin in millimeters',
    },
  ],
};

export default schema;
